import { useMemo } from 'react';
import { useOkapiKy } from '@folio/stripes/core';

export const OKAPI_TENANT_HEADER = 'X-Okapi-Tenant';

const useTenantKy = ({ tenantId } = {}) => {
  const ky = useOkapiKy();

  return useMemo(() => {
    return tenantId
      ? ky.extend({
        hooks: {
          beforeRequest: [
            request => {
              request.headers.set(OKAPI_TENANT_HEADER, tenantId);
            },
          ],
        },
      })
      : ky;
  }, [ky, tenantId]);
};

export default useTenantKy;
